module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACQSURBVEhL3ZVRCoAgEES9XVD3v0B1Dm2VV2S7QhiF9kBodsYd+tL9C+/9JGcNlcS7ckbWacRcyFYjO2bWacgEZAbW4SGzLCPzfgK/rQILIhr8tgqQCUYNFSCT5lN5FkQ0+N8VnMEyy3cYdVZgQUSD31YBMsHozwWvvwfxNXpSEpfLGVhXhnz5Vy8Qv53vCec2FGRg68letXkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-sliding-door-closet/light/24.png
// module id = 2424
// module chunks = 2